"use client"

import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Container, Typography, CircularProgress, Button, Box, Paper } from "@material-ui/core"
import { Link as LinkIcon } from "@material-ui/icons"
import firebase from "../firebase"

function Redirect() {
  const { id, gtin } = useParams()
  const [error, setError] = useState(null)
  const [targetUrl, setTargetUrl] = useState("")

  useEffect(() => {
    let cancelled = false

    const fetchRedirectUrl = async () => {
      try {
        console.log("Attempting to fetch document with ID:", id, "GTIN:", gtin || "none")

        const docRef = firebase.firestore().collection("qrcodes").doc(id)
        const doc = await docRef.get()

        if (cancelled) return

        if (doc.exists) {
          console.log("Document found:", doc.data())

          const docGtin = doc.data().gtin || ""
          if (gtin && docGtin !== gtin) {
            console.warn("GTIN mismatch:", docGtin, "vs", gtin)
          }

          const url = doc.data().url
          if (url == null || String(url).trim() === "") {
            if (!cancelled) {
              setError("QR code has no destination URL")
            }
            return
          }

          let redirectUrl = url
          if (!/^https?:\/\//i.test(url)) {
            redirectUrl = "https://" + url
          }

          if (!cancelled) {
            setTargetUrl(redirectUrl)
          }

          const qrData = doc.data()
          const delta = 1
          const eventGtin = qrData.gtin || gtin || ""

          // Contador agregado: separado del log para que un fallo en scanEvents
          // no frene el redirect ni el +1.
          try {
            await firebase.firestore().runTransaction(async (transaction) => {
              const docSnapshot = await transaction.get(docRef)
              if (!docSnapshot.exists) {
                throw new Error("Document does not exist!")
              }

              const newRedirects = (docSnapshot.data().redirects || 0) + delta
              transaction.update(docRef, { redirects: newRedirects })
              console.log("Redirect count updated successfully to:", newRedirects)
            })
          } catch (updateError) {
            console.error("Error updating redirects count:", updateError)
          }

          try {
            await firebase.firestore().collection("scanEvents").add({
              qrCodeId: id,
              gtin: eventGtin,
              createdAt: firebase.firestore.FieldValue.serverTimestamp(),
              delta,
            })
          } catch (eventError) {
            console.error("Error logging scan event:", eventError)
          }

          if (cancelled) return

          window.location.replace(redirectUrl)
        } else {
          console.error("Document not found for ID:", id)
          if (!cancelled) {
            setError(`QR code not found (ID: ${id})`)
          }
        }
      } catch (error) {
        console.error("Error fetching document:", error)
        if (!cancelled) {
          setError("Error: " + error.message)
        }
      }
    }

    if (id) {
      fetchRedirectUrl()
    } else {
      setError("No QR code ID provided")
    }

    return () => {
      cancelled = true
    }
  }, [id, gtin])

  const handleManualRedirect = () => {
    if (targetUrl) {
      window.location.replace(targetUrl)
    }
  }

  if (error) {
    return (
      <Container maxWidth="sm" style={{ marginTop: "5rem" }}>
        <Paper
          style={{
            padding: "2rem",
            borderRadius: "0.5rem",
            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
            animation: "fadeIn 0.5s ease-out",
          }}
        >
          <Typography variant="h5" color="error" gutterBottom style={{ textAlign: "center" }}>
            {error}
          </Typography>

          {targetUrl ? (
            <>
              <Typography gutterBottom style={{ textAlign: "center", marginTop: "1rem" }}>
                Click the button below to go to the destination:
              </Typography>
              <Box display="flex" justifyContent="center" marginTop={2}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleManualRedirect}
                  startIcon={<LinkIcon />}
                  style={{
                    backgroundColor: "#6366f1",
                    borderRadius: "0.5rem",
                    padding: "0.5rem 1.5rem",
                    textTransform: "none",
                  }}
                >
                  Go to destination
                </Button>
              </Box>
            </>
          ) : (
            <Typography gutterBottom style={{ textAlign: "center" }}>
              The QR code you scanned is invalid or has been removed.
            </Typography>
          )}
        </Paper>
      </Container>
    )
  }

  return (
    <Container
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Paper
        style={{
          padding: "3rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: "0.5rem",
          boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
          animation: "fadeIn 0.5s ease-out",
          width: "300px",
        }}
      >
        <CircularProgress size={56} thickness={4} style={{ color: "#6366f1" }} />
        <Typography variant="h6" style={{ marginTop: "1.5rem", color: "#1f2937" }}>
          Redirecting...
        </Typography>
        <Typography variant="body2" style={{ marginTop: "0.5rem", color: "#6b7280", textAlign: "center" }}>
          Please wait.
        </Typography>
      </Paper>
    </Container>
  )
}

export default Redirect
